import { ReactNode } from 'react'
import styled from 'styled-components'

import Text from '@/components/atomic/atoms/Text'

export interface Props {
  id?: string
  title?: string | ReactNode
  totalCount?: number
  unit?: string
  titleRightSide?: string | ReactNode
  contentSidePadding?: boolean
  'data-testid'?: string
  children: ReactNode
}

const ModuleContainer = ({
  id,
  title,
  totalCount,
  unit,
  contentSidePadding = false,
  titleRightSide,
  'data-testid': testId,
  children,
}: Props): JSX.Element => {
  return (
    <StyledContainer data-testid={testId} id={id}>
      {title && (
        <StyledTitleWrap>
          <StyledTitle type="title3" element="h2">
            {title}

            {totalCount && unit && (
              <>
                <StyledCount> {totalCount.toLocaleString()}</StyledCount>
                {unit}
              </>
            )}
          </StyledTitle>

          <StyledRightSideWrap>{titleRightSide}</StyledRightSideWrap>
        </StyledTitleWrap>
      )}

      <StyledContent $contentSidePadding={contentSidePadding}>{children}</StyledContent>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  background-color: white;
  padding: 26px 0;
`
const StyledTitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 26px 16px;
`
const StyledTitle = styled(Text)`
  display: flex;
  align-items: center;
`
const StyledCount = styled.span`
  color: ${({ theme }) => theme.colors.orange};
  margin-left: 6px;
`
const StyledRightSideWrap = styled.div``
const StyledContent = styled.div<{ $contentSidePadding: boolean }>`
  ${({ $contentSidePadding }) => $contentSidePadding && 'padding: 0 26px;'}
`

export default ModuleContainer
